import setUrlParam from './setUrlParam'

export default function ActivityCard ({ post, strings, setFilters, isEmbed }) {

  const allTerms = [
    { name: 'subject', terms: post.subjects },
    { name: 'area', terms: post.areas },
    { name: 'ageGroup', terms: post.ageGroup },
  ]
  const handleTermClick = (e) => {
    const value = e.currentTarget.dataset.termId
    const name = e.currentTarget.dataset.filterName

    setFilters(prevFilters => ({
      ...prevFilters,
      currentPage: 1,
      [name]: value,
    }))

    setUrlParam(name, value)
  }

  return (
    <div className="mtt-activities-card">
      <div className="mtt-activities-card__image">
        {post.imageUrl && (
          <img src={post.imageUrl} alt={post.title}/>
        )}
      </div>

      <div className="mtt-activities-card__content">
        <div className="mtt-activities-card__terms">
          {allTerms.map(({ name, terms }) => (
            Array.isArray(terms) && terms.length > 0 && terms.map(term => (
              <div
                key={term.term_id}
                className="mtt-activities-card__term"
                data-term-id={term.term_id}
                data-filter-name={name}
                onClick={handleTermClick}
              >
                {term.name}
              </div>
            ))
          ))}
        </div>

        {post.title && (
          <div className="mtt-activities-card__title">{post.title}</div>
        )}

        {post.excerpt && (
          <div className="mtt-activities-card__excerpt">{post.excerpt}</div>
        )}

        {post.fields && (
          <>
            <div className="mtt-activities-card__fields">
              {post.fields.address && (
                <div className="mtt-activities-card__field">
                  <div className="mtt-activities-card__field-label">
                    {strings.address}:
                  </div>
                  <div className="mtt-activities-card__field-value">
                    {post.fields.address}
                  </div>
                </div>
              )}

              {post.fields.opening_hours && (
                <div className="mtt-activities-card__field">
                  <div className="mtt-activities-card__field-label">
                    {strings.openingHours}:
                  </div>
                  <div className="mtt-activities-card__field-value">
                    {post.fields.opening_hours}
                  </div>
                </div>
              )}

              {post.fields.contact && (
                <div className="mtt-activities-card__field">
                  <div className="mtt-activities-card__field-label">
                    {strings.contact}:
                  </div>
                  <div className="mtt-activities-card__field-value">
                    {post.fields.contact}
                  </div>
                </div>
              )}
            </div>

            {post.fields.link?.url && post.fields.link?.title && (
              <a
                href={post.fields.link.url}
                className="button secondary"
                {...(isEmbed ? { target: '_blank', rel: 'noreferrer' } : {})}
              >
                {post.fields.link.title}
              </a>
            )}
          </>
        )}
      </div>
    </div>
  )
}